(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('SIMPLE_SEARCH_DELAY', 1000);
})();
